/**
 * ## Layout manager component
 *
 * @module src/components/layout
*/

'use strict';

const conf = require('../../config');

let isExpandedMax = false;
let isExpandedMin = false;
let isFullscreen = false;
let isEmbedFull = false;
let isEmbed = false;
let isEmbedExpanded = false;
let currentTab = 'waiting';

const headerHeight = 50;

let usage = 'standard';

let startup = false;

/**
 * Calendar display.
 */

const showStage = () => {
    $('body').css('display', 'block');
    resize();
};

const hideKeyboard = () => {
    document.activeElement.blur();
    $('input').blur();
};

const resize = () => {
    conf.vars.viewportWidth = $(window).width();
    conf.vars.viewportHeight = $(window).height();
    conf.vars.documentWidth = $(document).width();
    conf.vars.documentHeight = $(document).height();
    let placement = 25;
    if (conf.vars.NODE_ENV.indexOf('ios') > -1 || conf.vars.NODE_ENV.indexOf('android') > -1) {
        TweenMax.to('#component_catch', 0, { height: conf.vars.viewportHeight });
        TweenMax.to('#modal_block', 0, { height: conf.vars.viewportHeight });
    } else {
        placement = conf.vars.viewportHeight / 2 - $('#modal').outerHeight() / 2;
        if (conf.vars.viewportHeight <= 900) {
            placement = 10;
        } else if (conf.vars.viewportHeight <= 1024) {
            placement = conf.vars.viewportHeight / 3 - $('#modal').outerHeight() / 2;
        }
    }
    TweenMax.to('#modal', 0, {
        y: placement,
    });
    
    viewport();
};

const viewport = () => {
    let adjustmentHeight = 50;
    if (conf.vars.ui !== 'standard') {
        adjustmentHeight = 100;
    }
    $('#guide_block').css('height', `${conf.vars.viewportHeight}px`);
    $('#layout_main').css('height', `${conf.vars.viewportHeight}px`);
    $('#layout_chart').css('height', `${conf.vars.viewportHeight}px`);
    $('#content_wide_footer').css('top', `${conf.vars.viewportHeight - adjustmentHeight}px`);
    
    if (conf.vars.NODE_ENV.indexOf('ios') > -1) {
        $('#layout_alt_tables').css('bottom', '20px');
        $('#layout_alt_tables_live').css('bottom', '20px');
        $('#layout_sidebar').css('height', `${conf.vars.viewportHeight - 20}px`);
    } else {
        $('#layout_sidebar').css('height', `${conf.vars.viewportHeight}px`);
    }
    $('#layout_sidebar_shadow').css('height', `${(conf.vars.viewportHeight -
        $('#layout_sidebar_header').height())}px`);

    $('#login_bg').css('height', `${conf.vars.viewportHeight}px`);
    $('#login_bg').css('width', `${conf.vars.viewportWidth}px`);
    $('#login_shell').css('top', `${((conf.vars.viewportHeight / 2) - 75)}px`);
    // $('#loading').css('height', `${conf.vars.viewportHeight}px`);

    // notification block
    // $('#notification_block_right').css('height', `${conf.vars.viewportHeight}px`);

    // chart
    const chart_header_width = conf.vars.viewportWidth - $('#layout_sidebar').width();
    if (conf.vars.ui !== 'standard') {
        $('#layout_chart_header').css('width', '100%');
        $('#layout_sidebar').css('top', '50px');
    } else {
        $('#layout_chart_header').css('width', `${chart_header_width}px`);
        if (conf.vars.NODE_ENV.indexOf('ios') > -1) {
            $('#layout_sidebar').css('top', '20px');
        } else {
            $('#layout_sidebar').css('top', '0px');
        }
    }
    $('#layout_chart_rooms').css('width', `${chart_header_width}px`);
    const chart_main_height = conf.vars.viewportHeight; // - $('#layout_chart_header').height();
    // $('#layout_chart_main').css('height', chart_main_height + 'px');

    // standard sidebar
    const sidebar_content_height_standard = conf.vars.viewportHeight -
          $('#layout_sidebar_header').height() - $('#layout_sidebar_tabs_standard').height() -
          $('#layout_sidebar_titlebar_standard').height();
    if (conf.vars.NODE_ENV.indexOf('ios') > -1) {
        $('#layout_sidebar_content_standard')
            .css('height', `${sidebar_content_height_standard - 20}px`);
        $('#content_wide_footer')
            .css('top', `${conf.vars.viewportHeight - adjustmentHeight - 20}px`);
    } else {
        $('#layout_sidebar_content_standard').css('height', `${sidebar_content_height_standard}px`);
    }

    // wide sidebar
    const sidebar_content_height_wide = conf.vars.viewportHeight -
        $('#layout_sidebar_header').height() -
        $('#layout_sidebar_tabs_wide').height() -
        $('#layout_sidebar_titlebar_wide').height();
    $('#layout_sidebar_wide').css('width', `${(conf.vars.viewportWidth - 50)}px`);
    $('#layout_sidebar_content_wide').css('height', `${sidebar_content_height_wide}px`);
    // open (blockers)
    $('#layout_sidebar_open_max').css('height', `${(conf.vars.viewportHeight - 50)}px`);
    $('#layout_sidebar_open_min').css('height', `${(conf.vars.viewportHeight - 50)}px`);

    // chart wide
    $('#layout_chart').css('width', `${conf.vars.viewportWidth -
        ($('#layout_sidebar').outerWidth())}px`);
    /*
    if (usage === 'standard') {
        TweenMax.to('#zoom_in', speedx, {
            x: conf.vars.viewportWidth - ,
            ease: Power2.easeOut,
        });
    }
    */

    // temporary table editor sidebar blocker height
    $('#temp_editor_sidebar').css('height', `${conf.vars.viewportHeight - 50}px`);

    // notification bottom panel
    if ($('#notification').css('display') === 'block' &&
    $('#notification_center').css('border-top').substr(0, 1) === '0') {
        TweenMax.to('#notification', 0, {
            y: conf.vars.viewportHeight - $('#notification').height(),
        });
    }

    // reservations wide panel
    setTimeout(() => {
        if (conf.vars.viewportWidth >= 980) {
            const resWidth = conf.vars.viewportWidth - $('#content_wide_col2').width() - 77.5;
            $('#reservations_search').css('width', resWidth);
            $('#content_wide_col3').css('width', '288px');
        } else if (conf.vars.viewportWidth >= 768) {
            $('#content_wide_col3').css('width', conf.vars.viewportWidth - 460);
            $('#reservations_search').css('width', '100%');
        } else {
            $('#content_wide_col3').css('width', conf.vars.viewportWidth - 110);
        }
    }, 1);

    // stats wide panel
    const chartRatio = conf.vars.viewportHeight / conf.vars.viewportWidth;
    if (chartRatio < 0.66) {
        $('.content_wide_right').css('width', chartRatio * conf.vars.viewportWidth);
    } else {
        $('.content_wide_right').css('width', '80%');
    }

    // $('.panzoom').css('width', $('#layout_chart').width());
    // $('.panzoom').css('height', $('#layout_chart').height());
    if (conf.vars.ui === 'reservation') {
        startup = true;
        sidebarMaxOpenRes();
    } else if (conf.vars.ui === 'waitlist') {
        startup = true;
        sidebarMaxOpenWait();
    } else if (isExpandedMax) {
        sidebarMaxOpen(0);
    } else {
        sidebarMaxClose(0);
    }
    if (isExpandedMin) {
        sidebarMinOpen(0);
    } else {
        sidebarMinClose(0);
    }
    if (isFullscreen) {
        fullscreen(0);
    }
    if (isEmbed) {
        if (isEmbedExpanded) {
            embedExpanded(0);
        } else {
            embed(0);
        }
    } else if (isEmbedFull) {
        embedFull(0);
    }

    $('#layout_reslimit_main').css('height', `${(conf.vars.viewportHeight - 100)}px`);
    $('#layout_reslimit_main').css('width', `${(conf.vars.viewportWidth - 320)}px`);
    $('#layout_reslimit_range').css('height', `${(conf.vars.viewportHeight - 100)}px`);

    // check operational mode and reconfigure
    if (conf.vars.ui === 'standard') {
        $('#layout_chart_main').css('visibility', 'visible');
    }
    // resize();
};

$(document).ready(() => {
    $(window).resize(() => {
        setTimeout(() => {
            resize();
        }, 1);
    });
    window.addEventListener('orientationchange', () => {
        setTimeout(() => {
            resize();
        }, 1);
    });
});

const sidebarMaxOpen = (speedx) => {
    isExpandedMax = true;
    $('#layout_sidebar_open_max').css('display', 'block');
    TweenMax.to('#layout_sidebar_shadow', speedx, {
        x: 46,
        ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar', speedx, {
        width: conf.vars.viewportWidth - 50,
        ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_header_expand', speedx, {
        rotation: 180,
        transformOrigin: '50% 52%',
        ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_standard', speedx, {
        x: conf.vars.viewportWidth - 50,
        ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_wide', speedx, {
        x: 0,
        ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_in', speedx, {
        right: conf.vars.viewportWidth,
        ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_out', speedx, {
        right: conf.vars.viewportWidth,
        ease: Power2.easeOut,
    });
};

const sidebarMaxOpenRes = () => {
    isExpandedMax = true;
    $('#layout_sidebar_header').css('display', 'none');
    $('#layout_sidebar_open_max').css('display', 'none');
    $('#layout_sidebar_shadow').css('display', 'none');
    TweenMax.to('#layout_sidebar_content_wide', 0, {
        width: conf.vars.viewportWidth,
    });
    TweenMax.to('#layout_sidebar', 0, {
        width: conf.vars.viewportWidth,
    });
    TweenMax.to('#layout_sidebar_tabs_wide', 0, {
        width: conf.vars.viewportWidth,
    });
    $('#layout_sidebar_header_expand').css('display', 'none');
    TweenMax.to('#layout_sidebar_standard', 0, {
        x: conf.vars.viewportWidth,
    });
    TweenMax.to('#layout_sidebar_wide', 0, {
        x: 0,
    });
    setTimeout(() => {
        $('#layout_chart_header').css('width', '100%');
    }, 0);
    $('#zoom_in').css('display', 'none');
    $('#zoom_out').css('display', 'none');
    $('#layout_chart_header_expand').css('display', 'none');
    $('#layout_chart_header_4top_drop').css('display', 'none');
    $('#layout_chart_header_4top_desc').css('display', 'none');
    $('#layout_chart_header_daily').css('display', 'none');
};

const sidebarMaxOpenWait = () => {
    isExpandedMax = true;
    $('#layout_sidebar_header').css('display', 'none');
    $('#layout_sidebar_open_max').css('display', 'none');
    $('#layout_sidebar_shadow').css('display', 'none');
    TweenMax.to('#layout_sidebar_content_wide', 0, {
        width: conf.vars.viewportWidth,
    });
    TweenMax.to('#layout_sidebar', 0, {
        width: conf.vars.viewportWidth,
    });
    TweenMax.to('#layout_sidebar_tabs_wide', 0, {
        width: conf.vars.viewportWidth,
    });
    $('#layout_sidebar_header_expand').css('display', 'none');
    TweenMax.to('#layout_sidebar_standard', 0, {
        x: conf.vars.viewportWidth,
    });
    TweenMax.to('#layout_sidebar_wide', 0, {
        x: 0,
    });
    setTimeout(() => {
        $('#layout_chart_header').css('width', '100%');
    }, 0);
    $('#zoom_in').css('display', 'none');
    $('#zoom_out').css('display', 'none');
    $('#layout_chart_header_expand').css('display', 'none');
    $('#layout_chart_header_4top_drop').css('display', 'none');
    $('#layout_chart_header_4top_desc').css('display', 'none');
    $('#layout_chart_header_daily').css('display', 'none');
};

const sidebarMaxClose = (speedx) => {
    isExpandedMax = false;
    $('#layout_sidebar_open_max').css('display', 'none');
    TweenMax.to('#layout_sidebar_shadow', speedx, {
        x: conf.vars.viewportWidth - 224, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar', speedx, {
        width: 220, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_header_expand', speedx, {
        rotation: 0, transformOrigin: '50% 52%', ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_standard', speedx, {
        x: 0, ease: Power2.easeOut });
    TweenMax.to('#layout_sidebar_wide', speedx, {
        x: -conf.vars.viewportWidth + 50, ease: Power2.easeOut,
    });
    $('#zoom_in').css('display', 'block');
    $('#zoom_out').css('display', 'block');
    TweenMax.to('#zoom_in', speedx, {
        right: 235,
        ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_out', speedx, {
        right: 235,
        ease: Power2.easeOut,
    });
};

const sidebarMinOpen = (speedx) => {
    isExpandedMin = true;
    $('#layout_sidebar_open_min').css('display', 'block');
    TweenMax.to('#layout_sidebar_shadow', speedx, {
        x: conf.vars.viewportWidth - 54, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar', speedx, {
        right: -170, ease: Power2.easeOut,
    });
    $('#layout_chart').css('width', `${(conf.vars.viewportWidth - 50)}px`);
    TweenMax.to('#layout_chart', speedx, {
        width: conf.vars.viewportWidth - 50, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header_expand', speedx, {
        rotation: 180, transformOrigin: '50% 52%', ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header', speedx, {
        width: conf.vars.viewportWidth - 50, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms', speedx, {
        width: conf.vars.viewportWidth - 50, ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_in', speedx, {
        right: 65,
        ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_out', speedx, {
        right: 65,
        ease: Power2.easeOut,
    });
};

const sidebarMinClose = (speedx) => {
    isExpandedMin = false;
    $('#layout_sidebar_open_min').css('display', 'none');
    TweenMax.to('#layout_sidebar_shadow', speedx, {
        x: conf.vars.viewportWidth - 224, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar', speedx, {
        right: 0, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart', speedx, {
        width: conf.vars.viewportWidth - 220, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header_expand', speedx, {
        rotation: 0, transformOrigin: '50% 52%', ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header', speedx, {
        width: conf.vars.viewportWidth - 220, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms', speedx, {
        width: conf.vars.viewportWidth - 220, ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_in', speedx, {
        right: 235,
        ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_out', speedx, {
        right: 235,
        ease: Power2.easeOut,
    });
};

const fullscreen = (speedx) => {
    isFullscreen = true;
    TweenMax.to('#layout_sidebar', speedx, {
        right: -220, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_shadow', speedx, {
        x: conf.vars.viewportWidth, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_header', speedx, {
        x: conf.vars.viewportWidth, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header', speedx, {
        y: -headerHeight, width: conf.vars.viewportWidth, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header_shadow', speedx, {
        y: -headerHeight, ease: Power2.easeOut });
    TweenMax.to('#layout_chart_rooms', speedx, {
        width: conf.vars.viewportWidth, top: 0, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms_shadow', speedx, {
        width: conf.vars.viewportWidth, top: headerHeight, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart', speedx, {
        width: conf.vars.viewportWidth, ease: Power2.easeOut,
    });

    TweenMax.to('#zoom_in', speedx, {
        right: 15,
        ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_out', speedx, {
        right: 15,
        ease: Power2.easeOut,
    });
};

const embedFull = (speedx) => {
    isEmbedFull = true;
    isEmbed = true;
    isEmbedExpanded = false;
    TweenMax.to('#layout_sidebar', speedx, {
        right: -220, ease: Power2.easeOut,
    });
    // TweenMax.to('#layout_sidebar_standard', 0, {right: -220, ease: Power2.easeOut});
    TweenMax.to('#layout_sidebar_shadow', speedx, {
        x: $(window).width(), ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_header', speedx, {
        x: 220, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header', speedx, {
        y: 0, width: $(window).width(), ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header_shadow', speedx, {
        y: 0, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms', speedx, {
        width: $(window).width(), top: headerHeight, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms_shadow', speedx, {
        width: $(window).width(), top: 100, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart', speedx, {
        width: $(window).width(), ease: Power2.easeOut,
    });
};

const embed = (speedx) => {
    isEmbedFull = false;
    isEmbed = true;
    isEmbedExpanded = false;
    $('#tab_btn_addparty').css('display', 'none');
    $('#tab_btn_addparty_wide').css('display', 'none');
    $('#layout_sidebar_shadow').css('display', 'block');
    $('#layout_sidebar_header').css('display', 'block');
    $('#layout_sidebar_header_shadow').css('display', 'block');
    $('#layout_sidebar_tabs_standard').css('display', 'block');
    TweenMax.to('#layout_sidebar', speedx, {
        right: -220, ease: Power2.easeOut });
    TweenMax.to('#layout_sidebar_shadow', speedx, {
        x: $(window).width(), ease: Power2.easeOut,
    });
    TweenMax.to('#layout_sidebar_header', speedx, {
        x: $(window).width(), ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header', speedx, {
        y: 0 - headerHeight, width: $(window).width(), ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header_shadow', speedx, {
        y: 0 - headerHeight, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms', speedx, {
        width: $(window).width(), top: 0, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms_shadow', speedx, {
        width: $(window).width(), top: headerHeight, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart', speedx, {
        width: $(window).width(), ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_in', speedx, {
        right: 15,
        ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_out', speedx, {
        right: 15,
        ease: Power2.easeOut,
    });
};

const embedExpanded = (speedx) => {
    isEmbedFull = false;
    isEmbed = true;
    isEmbedExpanded = true;

    $('#layout_sidebar_open_max').css('display', 'none');
    $('#tab_btn_addparty').css('display', 'none');

    TweenMax.to('#layout_sidebar', speedx, {
        right: 0, ease: Power2.easeOut });
    $('#layout_sidebar_shadow').css('display', 'none');
    $('#layout_sidebar_header').css('display', 'none');
    $('#layout_sidebar_header_shadow').css('display', 'none');
    $('#layout_sidebar_tabs_standard').css('display', 'none');
    TweenMax.to('#layout_chart_header', speedx, {
        y: -headerHeight, width: $(window).width(), ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_header_shadow', speedx, {
        y: -headerHeight, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms', speedx, {
        width: $(window).width(), top: 0, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart_rooms_shadow', speedx, {
        width: $(window).width(), top: headerHeight, ease: Power2.easeOut,
    });
    TweenMax.to('#layout_chart', speedx, {
        width: $(window).width(), ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_in', speedx, {
        right: 235,
        ease: Power2.easeOut,
    });
    TweenMax.to('#zoom_out', speedx, {
        right: 235,
        ease: Power2.easeOut,
    });
};

const reset = () => {
    sidebarMaxClose(conf.vars.interfaceSpeed / 2);
    sidebarMinClose(conf.vars.interfaceSpeed / 2);
};

const getIsExpanded = () => {
    return isExpandedMax;
};

const getIsMin = () => {
    return isExpandedMin;
};


const toggleSidebarMax = () => {
    if (isExpandedMin) {
        toggleSidebarMin();
    } else {
        if (!isExpandedMax) {
            sidebarMaxOpen(conf.vars.interfaceSpeed / 2);
        } else {
            sidebarMaxClose(conf.vars.interfaceSpeed / 2);
        }
    }
};

const toggleSidebarMin = () => {
    if (!isExpandedMin) {
        sidebarMinOpen(conf.vars.interfaceSpeed / 2);
    } else {
        sidebarMinClose(conf.vars.interfaceSpeed / 2);
    }
};

const setUsage = (usageprop, kd) => {
    usage = usageprop;
    if (usageprop === 'embed') {
        $('#list_view').css('display', 'block');
        $('#layout_sidebar_tabs_standard').css('display', 'none');
        $('#tab_btn_addparty').css('display', 'none');
        $('#layout_chart_header_expand').css('display', 'none');
        $('#list_view').fastClick(() => {
            kd.send({
                type: 'rpc',
                action: 'list_view_return',
                payload: {},
            });
        });

        embed(0);
    }
    // resize();
};

const setCurrentTab = (tab) => {
    currentTab = tab;
};

const getCurrentTab = () => {
    return currentTab;
};


module.exports = {
    showStage,
    reset,
    resize,
    embed,
    embedFull,
    embedExpanded,
    getIsExpanded,
    getIsMin,
    setUsage,
    fullscreen,
    toggleSidebarMax,
    toggleSidebarMin,
    sidebarMaxOpen,
    sidebarMaxClose,
    sidebarMinOpen,
    sidebarMinClose,
    setCurrentTab,
    getCurrentTab,
    hideKeyboard,
};




/** WEBPACK FOOTER **
 ** ./src/components/layout/index.js
 **/